import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes, documentationActions } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  GET_PATIENT_DAILY_SESSION_FAILURE,
  GET_PATIENT_DAILY_SESSION_REQUEST,
  GET_PATIENT_DAILY_SESSION_SUCCESS,

  GET_PATIENT_DAILY_SESSION_LOADING,
} = dailySessionNotes;

const { RESET_DAILY_SESSION_NOTES_SIGN } = documentationActions;

function* getDailySessionPatientList(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PATIENT_DAILY_SESSION_LOADING });

    const response = yield call(
      dailySessionNotesService.getPatientList,
      payload?.payload,
      payload.source
    );
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_DAILY_SESSION_SUCCESS, payload: response.data });
      yield put({ type: RESET_DAILY_SESSION_NOTES_SIGN });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_DAILY_SESSION_FAILURE, payload: error });
  }
}

function* getDailySessionPatientListSaga() {
  yield takeEvery(GET_PATIENT_DAILY_SESSION_REQUEST, getDailySessionPatientList);
}

export default getDailySessionPatientListSaga;
